<div class="content page-gateway">
  <div class="container-fluid about">
    <div class="page-title license-title">
      <h1>
        {{'Gateway Settings' | translate}}
        <small>
          <a [routerLink]="'/help/gateway-setting'" target="_blank">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </a>
        </small>
      </h1>
      <button class="ui-button-danger float-right" type="button" pButton label="{{'Advanced Settings' | translate}}" icon="fa fa-cog" *ngIf="gatewayloaded && gatewayList.length !== 0" (click)="advancedSetting()"></button>
    </div>
    <div class="alert alert-danger flex" role="alert" *ngIf="gatewayloaded && gatewayList.length === 0">
      <span>{{'Before discovering and adding the device to the PowerPanel Cloud via SNMP, please ensure that you download and install the Gateway.' | translate}}</span>
      <a target="_blank" href="https://www.cyberpower.com/global/en/product/sku/powerpanel_cloud#downloads" class="btn btn-danger">{{'PowerPanel Gateway' | translate}}</a>
      <!-- <span>{{'Before discovering and adding the device to the PowerPanel Cloud via SNMP, please ensure that you download and install the PowerPanel Gateway.' | translate}}</span>
      <button type="button" pButton label="{{'PowerPanel Gateway' | translate}}" class="ui-button-danger" disabled="true"></button> -->
    </div>
    <div class="index-content">
      <div class="deviceRow gateway">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12" *ngFor="let item of gatewayList; let i=index;">
            <div class="device-content {{item.status}}">
              <div class="device-basicInfo">
                <div class="device-img col-xl-4 col-lg-4 col-md-4 col-sm-3">
                  <div class="img-size">
                    <img class="responsive-image" src="/assets/images/default_gateway.png">
                  </div>
                </div>
                <div class="device-info col-xl-8 col-lg-8 col-md-8 col-sm-9">
                  <div class="device-title">
                    <div class="name">
                      <h5>{{item.name}}</h5>
                    </div>
                    <div class="icon">
                      <span *ngIf="item.versionStatus === 0">
                        <i class="fa fa-check-circle normal"></i>
                      </span>
                      <span *ngIf="item.versionStatus === 1">
                        <i class="fa fa-info-circle" pTooltip="{{'New Version Available' | translate}}" tooltipPosition="bottom" tooltipStyleClass="available"></i>
                      </span>
                      <span *ngIf="item.versionStatus === 2" class="fa-stack custom-stack" pTooltip="{{'New Version Updating' | translate}}" tooltipPosition="bottom" tooltipStyleClass="tooltips_gary">
                        <i class="fa fa-circle"></i>
                        <i class="fa fa-refresh fa-stack-1x fa-inverse fa-spin"></i>
                      </span>
                    </div>
                    <!-- <a class="delete" (click)="showConfirmDialog(item)" [hidden]="item.hideDeleteBtn">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </a> -->
                  </div>
                  <div class="device-desc">{{item.status | translate}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashBoardTab" style="margin-bottom: 2em">
      <p-tabs [(value)]="gatewayType" (valueChange)="onTabChange($event)">
        <!-- <p-tabpanel header="{{'Connected Device' | translate}}" [selected]="gatewayType === 0 || gatewayType === undefined || gatewayType === null"></p-tabpanel>
        <p-tabpanel *ngIf="IsSuperAdmin || (!IsSuperAdmin && editProAuth)" header="{{'Auto-discovery' | translate}}"[selected]="gatewayType === 1"></p-tabpanel>
        <p-tabpanel *ngIf="IsSuperAdmin || (!IsSuperAdmin && editProAuth)" header="{{'SNMP Profile' | translate}}"[selected]="gatewayType === 2"></p-tabpanel> -->
        <p-tablist>
          <p-tab value="0">{{'Connected Device' | translate}}</p-tab>
          <p-tab *ngIf="IsSuperAdmin || (!IsSuperAdmin && editProAuth)" value="1">{{'Auto-discovery' | translate}}</p-tab>
          <p-tab *ngIf="IsSuperAdmin || (!IsSuperAdmin && editProAuth)" value="2">{{'SNMP Profile' | translate}}</p-tab>
        </p-tablist>
      </p-tabs>
    </div>
  </div>
  <app-connection-device *ngIf="gatewayType === '0'" [editProAuth]="editProAuth" [IsSuperAdmin]="IsSuperAdmin"></app-connection-device>
  <app-auto-discovery *ngIf="gatewayType === '1'"></app-auto-discovery>
  <app-snmp-profile *ngIf="gatewayType === '2'"></app-snmp-profile>
</div>


<!-- Confrim -->
<!-- <p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup">
  <div cla="page-content-body">
    <p translate>Are you sure you want to delete this Gateway?</p>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger" (click)="deleteGateway()"></button>
    <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog> -->

<!-- Warning -->
<p-dialog header="{{'Warning' | translate}}" [(visible)]="displayWarningDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <p translate>Please delete all devices added by this gateway and the discovery job associated with this gateway before deleting it.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger" (click)="displayWarningDialog=false"></button>
  </ng-template>
</p-dialog>
